export enum LayOutNameEnum {
  WEBSITE_LAYOUT = "website_layout",
  AUTH_LAYOUT = "auth_layout",
}

export enum StorageKeyEnum {
  PREVIEW_EDUCATION_ASSET = "preview_education_assets",
  JB_GLASS_AUTH_TOKEN = "jb_glass_auth_token",
  JB_GLASS_USER_INFO = "jb_glass_user_info",
  JB_GLASS_USER_PROFILE_PICTURE = "jb_glass_profile_picture",
  JB_GLASS_REMEMBER_ME_DATA = "Jb_glass_rememberMeData",
  WALL_ORDER_FILTER = "wall_order_filter",
  MODEL_FILTER = "model_filter",
  USER_FILTER = "user_filter",
  WALTZ_FINISH_FILTER = "waltz_finish_filter",
  WALTZ_VARIANT_FILTER = "waltz_variant_filter",
  MODEL_TAB_FILTER = "model_tab_filter",
  GLASS_ORDER_STATUS_FILTER = "glass_order_status_filter",
  GLASS_ORDER_DETAILS = "glass_order_details",
  WALL_ORDER_DETAILS = "wall_order_details",
  USE_MAXIMUM_DISCOUNT = "maximum_discount",
  WALTZ_ORDERS_SOLUTIONS = "waltz_orders_solutions",
  UNDER_MAINTENANCE = "under_maintenance",
  EDITED_MODULES_FOR_PRICING_VERSION = "edited_modules_for_pricing_version",
  JB_GLASS_PAY_NOW_ORDERS_DUE = "jb_glass_pay_now_orders_dues",
  JB_GLASS_PAY_FOR_DRAFT_TRANSACTION = "jb_glass_pay_for_draft_transaction",
  JB_GLASS_PAYMENT_HISTORY_FILTER = "jb_glass_payment_history_filter",
  JB_GLASS_WHATSAPP_HISTORY_FILTER = "jb_glass_WHATSAPP_history_filter",
  JB_GLASS_PAYMENT_REFUND_HISTORY_FILTER = "jb_glass_payment_refund_history_filter",
  EDITED_MODULES_FOR_PERCENT_UPDATE = "edited_modules_for_percent_update",
  DIRECTOTY_FILTER_REQ = 'directory_filter_req',
  DIRECTOTY_FILTER_TYPE = 'directory_filter_type',
  TREE_STRUCTURE_FOR_ACCESSORIES_DETAIL = 'treeStructureForAccessoriesDetail',
  TREE_STRUCTURE_FOR_GRID = 'treeStructureForGrid',
  TREE_STRUCTURE_FOR_SKIN_MAPPING = 'treeStructureForSkinMapping',
  MEETING_FILTER = "meeting_filter",
  B2B_FILTER = "b2b_filter",
  WORK_ORDER_FILTER_REQ = "work_order_filter_req",
  WORK_ORDER_TRACKER_FILTER_REQ = "work_order_tracker_filter_req",
  LOCATION_TRACKER_FILTER_REQ = "location_tracker_filter_req",
  RM_PROJECTION_FILTER_REQ = "rm_projection_filter_req",
  PROJECT_TRACKER_FILTER_REQ = "project_tracker_filter_req",
  PROJECT_TRACKER_ACTIVE_TAB = "project_tracker_active_tab",
  PROJECT_TRACKER_FLAG_FILTER_REQ = "project_tracker_flag_filter_req",
  DISPATCH_MANAGER_FILTER_REQ = 'dispatch_manager_filter_req',
  JB_GLASS_PM_BIC_FILTER_REQ_1 = "jb_glass_pm_bic_filter_req_1",
  JB_GLASS_DRAFT_BIC_SD_AWAITING_REQ = "jb_glass_draft_bic_sd_awaiting_req",
  JB_GLASS_DRAFT_BIC_SD_QUERY_REQ = "jb_glass_draft_bic_sd_query_req",
  SALES_PERSON_FILTER_REQ = "sales_person_filter_req",
  PRODUCTION_TEAM_WORK_FILTER_REQ = "production_team_work_filter_req",
  PRODUCTION_PENDING_FILTER_REQ = "production_pending_filter_req",
  DISPATCH_HOLD_FILTER_REQ = "dispatch_hold_filter_req",
  READY_FOR_DISPATCH_FILTER_REQ = "ready_for_dispatch_filter_req",
  PRODUCTION_PLANNED_FILTER_REQ = "production_planned_filter_req",
  MASTER_DELIVERY_ADVICE_DRIVER_DETAILS = "master_delivery_advice_driver_details",
  MASTER_DELIVERY_ADVICE_WORK_ORDER_DETAILS = 'master_delivery_advice_work_order_details',
  MASTER_DELIVERY_ADVICE_SELECTED_WORK_ORDERS = 'master_delivery_advice_selected_work_orders',
  MASTER_DELIVERY_ADVICE_SELECTED_OFFICES = 'master_delivery_advice_selected_offices',
  MASTER_DELIVERY_ADVICE_INVOICE_DETAILS = 'master_delivery_advice_invoice_details',
  MASTER_DELIVERY_ADVICE_UUID = 'master_delivery_advice_uuid',
  MASTER_DELIVERY_ADVICE_STEP_NUMBER = 'master_delivery_advice_step_number',
  MASTER_DELIVERY_LOADING_IMAGES = 'master_delivery_loading_images',
  MASTER_DELIVERY_DA_SERIAL_OFFICE_WISE_AND_MDA = "master_delivery_da_serial_office_wise_and_mda",
  JB_CONNECT_MEETING_START = "meeting_start",
  MAINTENANCE_ALERT_HIDDEN = "maintenance_alert_hidden",
  WALTZ_STAGE = "waltz_stage",
  DRAWING_ANNOTATION = "drawing_annotation",
  DRAWING_SET_DETAILS_FOR_WALTZ_ORDER = "drawing_set_details_for_waltz_order",
  DRAWING_ANNOTATION_FOR_WALTZ_ORDER = "drawing_annotation_for_waltz_order",
  ANNOTATION_COORDINATES_FOR_WALTZ_ORDER = "annotation_coordinates_for_waltz_order",
  DRAWING_UUID = "drawing_uuid",
  ANNOTATION_DELETE_IDS = "annotation_delete_ids",
  EXISTING_SOLUTIONS_IDS_FOR_DRAWING_PLAN = "existing_solutions_ids_for_drawing_plan",
  EXISTING_FLOOR_PLAN_SETS_IDS = "existing_floor_plan_sets_ids",
  UPLOADED_SHOP_DRAWINGS = 'uploaded_shop_drawings',
  SD_ORDER_DETAILS = 'sd_order_details',
  SD_SELECTED_SOLUTIONS_DDL = 'sd_selected_solutions_ddl',
  SD_SELECTED_SOLUTION_FOR_STAMP = 'sd_selected_solution_for_stamp',
  SD_STAMP_ORDER_DETAIL = "sd_stamp_order_detail",
  SOCIAL_LEADS_FILTER = "social_leads_filter",
  INITIAL_DRAWING_COORDINATION = "initial_drawing_coordination",
  INITIAL_DRAWING_PLANS = "initial_drawing_plan",
  JB_GLASS_EMAIL_HISTORY_FILTER = "jb_glass_EMAIL_history_filter",
  STORE_MAP_DETAIL_FOR_SD_AWAITING = "store_map_detail_for_sd_awaiting",
  STORE_SELECTED_SOLUTION_INDEXES_FOR_SD_AWAITING = 'store_selected_solution_indexes_for_sd_awaiting',
  STORE_SELECTED_SOLUTION_INDEXES_FOR_PD_READY = 'store_selected_solution_indexes_for_pd_ready',
  USER_DATA = "USER_DATA",
  JB_GLASS_USER = "JB_GLASS_USER",
  ONLINE_USERS_FILTER_KEY = "ONLINE_USERS_FILTER",
  OBSERVATION_ERROR_STORE_KEY = "observation-error-store",
  USER_REASSIGN_DETAILS = "user_reassign_details"
}

export enum ModelsFileEnum {
  ORIENTATION_IMAGE_PATH = "orientationImagePath",
  SUB_ORIENTATION_REF_IMAGE_PATH = "subOrientationImagePath",
  PSE_IMAGE_PATH = "PSEImagePath",
  MEASUREMENT_SHEET_IMAGE_PATH = "measurementSheetImagePath",
  CAD_TEMPLATE_IMAGE_PATH = 'CADTemplateImagePath',
}

export enum ActionEntityEnum {
  LIST = "list",
  VIEW = "view",
  UPDATE = "update",
  DELETE = "delete",
  CREATE = "create",

  LOCATION_DESCOPE = 'Location_Descope',
}

export enum GlassCount {
  ONE = "ONE",
  TWO = "TWO",
}

export enum IdReferenceType {
  PAN = "PAN",
  GST = "GST",
}

export enum TeamTypeEntity {
  SALES = "SALES",
  EXECUTION = "EXECUTION",
  SOCIALS = "SOCIALS",
  FACTORY = "FACTORY"
}

export enum OrderStatusEnumEntity {
  SYSTEM_ERROR = "system-error",
  DRAFT = "draft",
  PIPELINE = "pipeline",
  EDITED = "edited",
  COMMERCIALHOLD = "commercial-hold",
  COMMERCIALWIN = "win",
  HANDOVER = "handover",
  OLDWIN = "old-win",
  ALL = "all",
  EXPIRED = "expired",
  LOST = "lost",
  HANDOVER_PENDING = "handover-pending",
  FEEDBACK = "feedback",
  PRECLOSURE = 'preclosure',
  FULL_DISPATCH = "full-dispatch"
}

export enum OfficeTypeEnum {
  JBOFFICE = "JBOffice",
  DEALEROFFICE = 'dealerOffice'
}

export enum ArchitectDetailsValidationStatus {
  PENDING = "pending",
  APPROVED = "approved"
}

export enum ContactTypeEnumEntity {
  ARCHITECT = 1,
  CLIENT = 2,
  TRADER = 3
}

export enum VersionStatus {
  DRAFT = "draft",
  LIVE = "live",
}

export enum VisibleOrdersEnumEntity {
  ALL = 'all',
  SELF = 'self',
  SELF_OFFICE = 'selfOffice',
  ASSIGNED = "assigned"
}

export enum UserProfileEnumEntity {
  ADMIN = "Admin",
  ACCOUNTANT = "Accountant",
  SALES_PERSON = "Sales person",
  SALES = "Sales",
  PROJECT_MANAGER = "Project manager",
}

export enum RegionEnum {
  DOMESTIC = "domestic",
  EXPORT = "export"
}

export enum OnlyGlassFinishFileEnum {
  IMAGE_THUMBNAIL_PATH = "imageThumbnailPath",
  IMAGE_ORIENTATION_PATH = "imageOrientationPath",
  IMAGE_POTRAIT_PATH = "imagePotraitPath",
  IMAGE_APPLICATION_PATH = "imageApplicationPath",
}

export enum GlassVariantsFileEnum {
  IMAGE_THUMBNAIL_PATH = "thumbnailImagePath",
  IMAGE_POTRAIT_PATH = "portraitImagePath",
  IMAGE_WALTZ_VARIANT_PATH = "imagePath",
}

export enum SettingModuleCategoryEnum {
  GENEAL_SETTINGS = "generalSettings",
  WALTZ_ORDER = "waltzOrder",
  ACCESSORIES = "accessories",
  GLASSCATALOGUES = "glass-catalogues",
  JB_CONNECT_APP = "jb-connect-app",
  INVOICE = "invoice",
  PRODUCTION_MASTERS = "production-masters",
  CS_MASTER = "cs-master"
}

export enum ValueMethodEnumEntity {
  VALUE = "VALUE",
  PERCENT = "PERCENT",
}

export enum CampaginSendThroughEntity {
  MAIL = "MAIL",
  WHATSAPP = "WHATSAPP",
  BOTH = "BOTH"
}

export enum CampaginShareEntity {
  SHARE_NOW = "SHARE_NOW",
  SCHEDULE_SHARE = "SCHEDULE_SHARE"
}

export enum CampaginArchitectListStatusEntity {
  ALL = 'ALL',
  SUCCESS = "SUCCESS",
  FAILED = 'FAILED'
}

export enum MatteOptionEnumEntity {
  YES = "YES",
  NO = "NO",
}

export enum ConfirmationYesNoEnumEntity {
  YES = "YES",
  NO = "NO",
  NOT_APPLICABLE = "N/A"
}

export enum FactoryPromiseTypeEnumEntity {
  MANUAL = "manual",
  AUTOMATIC = "automatic"
}

export enum SecondaryFactorsEnum {
  WITH_IN = 'withIn',
  CROSS = 'cross',
  NA = 'na',
  EXPORT = 'export',
}

export enum PunchItemTypeEnum {
  SUBFRAME = "SUBFRAME",
  SUBTRACK = "SUBTRACK",
  NONE = "NONE"
}

export enum PackingTypeEnumEntity {
  LOCATION = "location",
  SUBFRAME = "subframe",
  SUBTRACK = "subtrack"
}

export enum DelivaryAddressStatusEnum {
  DEALEROFFICE = "dealerOffice",
  PROJECT = "project"
}

export enum PaymentTransactionEnum {
  INITIATED = "initiated",
  INPROGRESS = "inprogress",
  SUCCESSFUL = "successful",
  FAILED = "failed",
  CASH_CHALLAN_GENERATED = 'cash_challan_generated',
  CHEQUE_CHALLAN_GENERATED = 'cheque_challan_generated',
  RTGS_CHALLAN_GENERATED = 'rtgs_challan_generated',
  NEFT_CHALLAN_GENERATED = 'neft_challan_generated',
  WIRE_CHALLAN_GENERATED = 'wire_challan_generated',
  PENDING_FOR_CHECKER_APPROVAL = 'pending_for_checker_approval',
  ICICI_SYSTEM_ERROR = 'icici_system_error',
  RIP = 'rip',
  SIP = 'sip',
  SETTLED = 'settled',
  UPDATE_MANUALLY = 'updated_manually',
  SCHEDULER_UPDATES = 'scheduler_updates',
}

export enum SolutionCategoryEnum {
  GLASS = 'GLASS',
  WALTZ = 'WALTZ',
  ACCESSORY_ONLY = "ACCESSORY ONLY",
}
export enum ArchitectDetailsRadioSelectionEnum {
  ARCHITECT_EXISTE = 'architect_exists',
  ARCHITECT_NOT_DISCLOSED = 'architect_not_disclosed'
}

export enum ArchitectUserType {
  PRINCIPAL = "PRINCIPAL",
  ASSOCIATE = "ASSOCIATE"
}

export enum DirectoryStatusType {
  USER_TYPE = "USER_TYPE",
  CATEGORY = "CATEGORY"
}

export enum CampaignStatusEnumEntity {
  COMPLETED = "Completed",
  SCHEDULED = "Scheduled",
  IN_PROGRESS = "In Progress",
  DRAFT = "Draft",
  PENDING = "Pending",
}

export enum TeamStatusRedFlag {
  JARVIS_TEAM = "Jarvis Team",
  ACCOUNTS_TEAM = "Accounts Team",
  CS_PRODUCTION_SOFTWARE = "CS (Production Software)"
}

export enum ChargeByTypeEnumEntity {
  SQFT = "sqft",
  DIMENTION = "dimension"
}

export enum RibbonEnumEntity {
  RED_RIBBON = "Red Ribbon",
  COMMERCIAL_HOLD = "Commercial Hold",
  FEEDBACK_PENDING = "Feedback Pending",
  HANDOVER_PENDING = "Handover Pending",
  SELF_PERMISSION = "self",
  RR_PRODUCTION_HOLD_WO = "RR_Production Hold WOs",
  RR_PRODUCTION_PLANNED_WO = "RR_Production Planned WOs",
  RR_TBS_HOLD_WO = "RR_TBS Hold WOs",
  RR_IN_PRODUCTION_WO = "RR_In Production WOs",
  RR_DISPATCH_HOLD_WO = "RR_Dispatch Hold WOs",
  RR_READY_FOR_DISPATCH_WO = "RR_Ready for Dispatch WOs",
  RR_DISPACTH_PLANNED_WO = "RR_Dispatch Planned WOs",
  RR_DELIVERED_WOS = 'RR_Delivered WOs',
  RR_MAPPING_PENDING_PIPELINE_ORDERS = "RR_mapping pending pipeline orders",
  RR_MAPPING_PENDING_WIN_ORDERS = "RR_mapping pending win orders",
  OVER_DUE = "Over Due",
  NOT_FEASIBLE_ORDERS = "Not Feasible Orders",
  SHOP_DRAWING_AWAITING_ORDER = "Shop Drawing Awaiting Order",
  SHOP_DRAWING_APPROVAL_PENDING_ORDER = "Shop Drawing Approval Pending Order",
  SOCIAL_LEAD_ORDER = "Social Lead Order",
  MEASUREMENT_SHEET_PENDING_ORDER = "Measurement Sheet Pending Order",
  MEASUREMENT_SHEET_QUERY_PENDING_ORDER = "Measurement Sheet Query Pending Order",
  SITE_NOT_READY_PENDING_ORDERS = "Site Not Ready Pending Order",
  SHOP_DRAWING_QUERY_PENDING_ORDER = "Shop Drawing Query Pending Order",
  RR_POLICY_EXPIRY_OR_REMAINING_AMOUNT = "RR_Policy expiry or remaining amount",
  RR_ERROR_WORK_ORDER_PENDING_RECORDS = "RR_Error Work Order Pending Records",
  RR_EXTRA_WORK_ORDER_PENDING_RECORDS = "RR_Extra Work Order Pending Records",
  TO_BE_SUPPLY_IN_TRANSIT_RECORDS = "To Be Supply In Transit Records",
  RR_PROMISE_DAYS_EXCEEDED_WO = "RR_Promise Days Exceeded WOs",
  CREDIT_NOTE_RETRY_RECORDS = "Credit Note Retry Records",
}

export enum QtyTypeEnumEntity {
  RANGE = "range",
  DEFAULT = "default"
}

export enum GlassAccessory {
  SKIN = "SKIN",
  ACCESSORY = "ACCESSORY",
}

export enum ImportArchitectListTypeEnumEntity {
  ARCHITECT = 'architect',
  USER = 'user'
}

export enum ColorCodeEnumEntity {
  GREEN = "Green",
  RED = "Red",
  ORANGE = 'Orange',
  GREY = "Grey"
}

export enum ProLevelEnum {
  PRO = "PRO",
  PROPLUS = "PROPLUS",
  ARCHITECT = "Architect"
}
export enum BulkActionsEntity {
  UPDATE_TAG = "update-tag",
  DOWNLOAD = "download",
  SHARE = "share",
  MOVE = "move"
}

export enum UserSignInTrackEnumEntity {
  WEB_APP = "webapp",
  WEBSITE = "website"
}

export enum JbConnectContactSourceEnumEntity {
  SCAN = 'Scan',
  MANUAL = 'Manual',
  COPY_LINK = 'Copy Link',
  TRADER_BY_SOCIAL = 'Trader By Social'
}

export enum WhatsappQueueTypeEntity {
  CAMPAIGN = 'campaign',
  CAMPAIGN_TRAIL = 'campaign_trail',
  JB_CONNECT = "jb_connect",
  WEBHOOK_REPLY = 'webhook_reply',
  ORDER_WIN = 'order_win',
  REFUND_PAYMENT = 'refund_payment',
  SYSTEM_ERROR_ORDERS = 'system_error_orders',
  MARCH_25_FOLLOWUP = 'MARCH_25_FOLLOWUP',
  MARCH_25_FOLLOWUP_ACTION_TAKEN = 'MARCH_25_FOLLOWUP_ACTION_TAKEN',
  EVENT = 'event',
  DELIVERY_ADVICE = 'delivery_advice',
  MASTER_DELIVERY_ADVICE = 'master_delivery_advice',
  GENERATE_ORDER = "generate_order",
  TRUST_MATTER = "trust_matter",
  FEEDBACK_MATTER = "feedback_matter",
  SALES_DAILY_REPORT_JB_CONNECT = "Sales Daily report - JB Connect",
  REGIONAL_HEAD_DAILY_REPORT_JB_CONNECT = "Regional Head Daily report - JB Connect",
  NATIONAL_HEAD_DAILY_REPORT = "National Head Daily report - JB Connect",
  START_MEETING_JB_CONNECT = "Start Meeting - JB Connect",
  NEW_LEAD_JB_CONNECT = "New lead - JB Connect",
  JB_CONNECT_APP = "JB Connect",
  ARCHITECT_LIFETIME_EXPORT = "Architect Lifetime Project Export - JB Connect",
  ARCHITECT_FIRM_EXPORT = "Architect Firm Export - JB Connect",
  QUOTE_EXPORT_JB_CONNECT_APP = "Quote Export - JB Connect",
  LEDGER_EXPORT_JB_CONNECT_APP = "Ledger Export - JB Connect",
  ORDER_EXPORT_JB_CONNECT_APP = "Order Status Export - JB Connect",
  ALL_PROJECT_EXPORT_JB_CONNECT = "All Project Export - JB Connect",
  USER_AUTHENTICATION = "User Authentication",
  PRE_WORK_ORDER = "Pre Work Order",
  ID_EVENT_USER_INVITATION = "ID Event User Invitation",
  ID_EVENT_VISITOR = "ID Event Visitor",
  ID_EVENT_SALES = "ID Event Sales",
  REPORT_ERROR = "Report Error",
  WORK_ORDER_APPROVAL_VERIFICATION = "Work Order Approval Verification",
  MARCH_25_FOLLOWUP_ACTION_ARRANGE_A_CALL = "MARCH_25_FOLLOWUP_ACTION_ARRANGE_A_CALL",
  RETURN_ERROR = "Return Error",
  TRUST_SEAL_SEND_OTP = "trust_seal",
  TRUST_SEAL_SEND_DOCUMENTS = "jb_glass_trust_seal_documents"
}

export enum WorkOrderTypeEnum {
  ER = "er",
  WO = "wo"
}

export enum WhatsAppQueueStatusEnum {
  COMPELETED = "completed",
  IN_PROGRESS = "in_progress",
  FAILED = "failed",
  PENDING = "pending"
}

export enum WhatsappWebHookStatusEntity {
  DELIVERED = 'delivered',
  READ = 'read',
  FAILED = 'failed',
  SENT = 'sent'
}

export enum MeetingConfigurationCategoryEnumEntity {
  ARCHITECT = 'Architect',
  CLIENT = 'Client',
  TRADER = 'Trader'
}

export enum WorkOrderTypeEntity {
  PENDING_WORK_ORDER = "pending-work-order",
  READY_WORK_ORDER = "ready-work-order",
  EXECUTION_ORDER = "execution-order",
  PRODUCTION_HOLD_WORK_ORDER = "production_hold_work_order",
  PRODUCTION_PLANNED_WORK_ORDER = "production_planned_work_order"
}


export enum WorkOrderStatusEnumEntity {
  PRODUCTION_HOLD = "production-hold",
  TBS_HOLD = "tbs-hold",
  PRODUCTION_PLANNED = "production-planned",
  IN_PRODUCTION = "in-production",
  DISPATCH_HOLD = "dispatch-hold",
  READY_FOR_DISPATCH = "ready-for-dispatch",
  PLANNED_FOR_DISPATCH = "planned-for-dispatch",
  // DISPATCHED = "dispatched",
  IN_TRANSIT = "in-transit",
  DELIVERED = "delivered",
  FULL_DISPATCH = "full-dispatch"
}

export enum ProductionFloorStatusEnumEntity {
  HOLD = "hold",
  RELEASE = "release",
}

/** who placed a location hold: the production floor (factory) or a sales user from the WO Tracker */
export enum LocationHoldTypeEnumEntity {
  FACTORY = "factory",
  SALES = "sales",
}

/** one hold episode's state in the location hold history */
export enum LocationHoldHistoryStatusEnumEntity {
  ACTIVE = "active",
  RELEASED = "released",
}

export enum LocationTrackerQueryFlagEnumEntity {
  ON_HOLD = "on_hold",
  NOT_ON_HOLD = "not_on_hold",
}

export enum LocationTrackerPaintFlagEnumEntity {
  ON_PAINT = "on_paint",
}

export enum LocationTrackerPromiseFlagEnumEntity {
  AWAITING_DATE = "awaiting_date",
  ON_TRACK = "on_track",
  OVERDUE = "overdue",
  FAILED = "failed",
  TOMORROW_OVERDUE = "tomorrow_overdue",
  FAST_TRACK = "fast_track",
}

export enum LocationTrackerPromiseDaysFlagEnumEntity {
  NO_DATE = "no_date",
  LESS_THAN = "less_than",
  MORE_THAN = "more_than",
  CUSTOM = "custom",
  // promise date falls between tomorrow and N days from today (inclusive), used by the
  // Location Tracker and WO Tracker pages' promise-days filter and the header's promise-days ribbon
  NEXT = "next",
  // promise date falls between an explicit start and end date (inclusive), used by the
  // Location Tracker and WO Tracker pages' promise-days filter
  CUSTOM_DATE = "custom_date",
}

export enum WorkOrderPromiseDateRequestStatusEnumEntity {
  PENDING = "pending",
  APPROVE = "approve",
  REJECT = "reject",
}

export enum LocationTrackerSolutionStatusEnumEntity {
  IN_PRODUCTION = "in-production",
  READY = "ready",
}

export enum InvoiceWorkOrderStatusEnumEntity {
  IN_TRANSIT = "in-transit",
  DELIVERED = "delivered"
}

export enum SolutionPunchItemTypeEnumEntity {
  LOCATION_LEVEL = 'Location Level',
  SUBFRAME = 'Sub Frame',
  SUBTRACK = 'Sub Track',
  PROJECT_LEVEL = 'Project Level',
  PANEL_LEVEL = 'Panel Level',
  NA = 'N/A',
  ACCESSORY_ONLY = "Accessory Only"
}

/** the project tracker drawer document a flag is raised on */
export enum ProjectTrackerDocumentTypeEnum {
  SHOP_DRAWING = "shop-drawing",
  MEASUREMENT_SHEET = "measurement-sheet",
}

/** the project directory role a project tracker flag is addressed to */
export enum ProjectTrackerDirectoryRoleEnum {
  SITE_MANAGER = "site-manager",
  DRAFTSMAN = "draftsman",
  SALES_PERSON = "sales-person",
}

/** a project tracker document flag's life: open when raised, closed once marked so from the Flagged Documents tab */
export enum ProjectTrackerDocumentFlagStatusEnum {
  OPEN = "open",
  CLOSED = "closed",
}

/** the project tracker listing's next action filter, judged on the project's latest next action day against today */
export enum ProjectTrackerNextActionFilterEnum {
  OVERDUE = "overdue",
  DUE_TODAY = "due-today",
  NEXT_7_DAYS = "next-7-days",
  OVERDUE_AND_TODAY = "overdue-today",
  NOT_SET = "not-set",
}

export enum StartMeetingTypeEnum {
  NEW_CLIENT = '1',
  NEW_ARCHITECT = '2',
  EXISTING_ARCHITECT = '3',
  ORDER_ID = '4',
  NEW_TRADER = '5',
}
export enum OfficeModelsEnumEntity {
  ASSIGN_USER_MODAL = 'assignUserModal',
  FILE_UPLOAD_MODAL = 'uploadFileModal'
}

export enum ProductionPlanningEnumEntity {
  MASTER_DA = 'Master DA'
}

export enum DrawingTypeEnumEntity {
  SHOP_DRAWING = 'Shop drawing',
  PRODUCTION_DOCS = 'Production DOCS',
}


export enum VerifySolutionListActionEnumEntity {
  CHANGED = "changed",
  UNCHANGED = "unchanged",
  ADDED = "added",
  DELETED = "deleted",
  LOCATION_DESCOPE = "Location_Descope"
}
export const TraderPrimeContactId = '67b30ea400eae240e7330f0a';

export enum RoleSystemCategoryEnumEntity {
  PROJECT_MANAGER = "project-manager",
  DRAFTSMAN = "draftsman",
  SITE_MANAGER = "site-manager"
}

export enum DownloadTypeEnum {
  EXCEL = "excel",
  PDF = "pdf"
}

export enum SplitPDFStatusEntity {
  PENDING = "pending",
  APPROVED = "approved"
}

export enum WaltzStageEnumEntity {
  LOCATION = "location",
  FLOOR_PLAN = "floor_plan",
  PROJECT_DIRECTORY = "project_directory",
  SOLUTION_HISTORY = "solution_history",
  SD_APPROVE = "sd_approve",
  NOT_FEASIBLE = "not_feasible",
  REVERT_SOLUTION = "revert_solution",
  PROCORE_DRIVE = "procore_drive"
}


export enum SystemLegendsEnumEntity {
  SWING = "66360c58f7231385747e2f7c",
  SLIDE = '66360c58f7231385747e2f79',
  GLIDE = '66360c58f7231385747e2f76',
  CLOSE = '66360c58f7231385747e2f73'
}

export enum PunchItemWiseStatuesEnum {
  MEASUREMENT_SHEET_PENDING = "measurement-sheet-pending",
  MEASUREMENT_SHEET_QUERY = "measurement-sheet-query",
  SHOP_DRAWING_AWAITING = "shop-drawing-awaiting",
  SHOP_DRAWING_APPROVAL_PENDING = "shop-drawing-approval-pending",
  SHOP_DRAWING_APPROVED = "shop-drawing-approved",
  SHOP_DRAWING_QUERY = "shop-drawing-query",
  PRODUCTION_HOLD = "production-hold",
  TBS_HOLD = "tbs-hold",
  PRODUCTION_PLANNED = "production-planned",
  IN_PRODUCTION = "in-production",
  DISPATCH_HOLD = "dispatch-hold",
  READY_FOR_DISPATCH = "ready-for-dispatch",
  PLANNED_FOR_DISPATCH = "planned-for-dispatch",
  DISPATCHED = "dispatched",
  DELIVERED = "delivered",
  SITE_NOT_READY = "site-not-ready",
  SITE_READY = "site-ready",
  NOT_FEASIBLE = "not-feasible",
  FEASIBLE = "feasible",
  TECHNICIAN_NOT_ASSIGNED = "technician-not-assigned",
  INSTALLATION_HOLD = "installation-hold",
  INSTALLATION_PENDING = "installation-pending",
  INSTALLATION_REVIEW_PENDING = "installation-review-pending",
  INSTALLATION_REJECTED = "installation-rejected",
  HANDOVER = "handover",

  SUB_TRACK_NOT_REQUIRED = "sub-track-not-required",
  LOCATION_DESCOPE = "location-descope",

  EXTRA_COST_APPROVAL_PENDING = "extra-cost-approval-pending",
  ERROR_COST_APPROVAL_PENDING = "error-cost-approval-pending",
}

export enum WorkOrderTypeEnumEntity {
  WO = "wo",
  ERROR_WO = "er",
  EXTRA_WO = "ex"
}

export enum DrawingDetailFolderNameEntity {
  SD_APPROVED = "SD Approved",
  SD_AWAITING = "SD Approval Pending",
  KEY_PLAN = "Key Plan",
  DUMP_DRAWING = "Dump Drawings",
  LOADED_DOCUMENTS = "Loaded Documents",
  MEASUREMENT_SHEET = "Measurement Sheet",
  REVISION_FILE = "Revision File",
  PROCORE_FD = "Procore FD",
  PROCORE_SD = "Procore SD"
}

export enum CreditNoteResponseStatusEnumEntity {
  GENERATED = "GENERATED",
  CANCELLED = "CANCELLED",
  RETRY = "RETRY"
}

export enum AutoSearchTypeEnumEntity {
  ADDRESS = 'address',
  POSTCODE = 'postcode'
}

export enum MismatchedCityAndPostcodeEnumEntity {
  PINCODE_CITY_MISMATCH = 'PINCODE_CITY_MISMATCH',
}

export enum EmailQueueStatusEnumEntity {
  COMPELETED = "completed",
  IN_PROGRESS = "in_progress",
  FAILED = "failed",
  PENDING = "pending"
}

export enum EmailQueueTypeEnumEntity {
  UPDATE_ORDER = "updateOrderStatus",
  FAILED_PROJECT_STATUS_TO_INACTIVE = "failedToChangeProjectStatusToInactive",
  CAMPAIGN = 'campaign',
  CAMPAIGN_TRAIL = 'campaign_trail',
  EXPIRED_ORDER = 'expiredOrder',
  MAIL_TO_PRIME_CONTACT = 'mailToPrimeContact',
  MAIL_FOR_EXPORT_ORDER_SOLUTION_PRICING_DIFFERENCE = 'exportOrderSolutionPricingDifference',
  MAIL_TO_CUSTOMER = 'mailToCustomer',
  FAILED_TO_ADD_ARCHITECT_USER = 'failedToAddArchitectUser',
  MAIL_TO_USER_FOR_OTP = 'mailToUserForOTP',
  MAIL_TO_SALES_PERSON = 'mailToSalesPerson',
  NOTIFICATION_TO_ADMIN_FOR_VALIDATE_ARCHITECT = 'notificationToAdminForValidateArchitect',
  EMAIL_FOR_ARCHITECT_CATEGORY = 'EmailForArchitectCategory',
  VERIFICATION_CODE_FOR_REFUND_PAYMENT = 'VerificationCodeForRefundPayment',
  MAIL_FOR_EXPORT_DOCUEMENT = 'mailForExportDocuement',
  EMAIL_TO_BANKING_DEALER_FOR_REFUND_INITIATED = 'emailToBankingDealerForRefundInitiated',
  EMAIL_TO_BANKING_DEALER_FOR_REFUND_RESPONSE = 'emailToBankingDealerForRefundResponse',
  DELIVERY_ADVICE = 'delivery_advice',
  MASTER_DELIVERY_ADVICE = 'master_delivery_advice',
  EVERY_DAY_REPORTS_FOR_FLOOR_PLAN = 'every_day_reports_for_floor_plan',
  EMAIL_TO_USER_AFTER_PROJECT_HANDOVER = 'email_to_user_after_project_handover',
  EVERY_DAY_REPORTS_FOR_SURVEY_TRACKING = 'every_day_reports_for_survey_tracking',
  MAIL_TO_USER_FOR_ANALYTICS_DOWNLOAD = 'analytics_export'
}

export enum ObservationErrorStatusEnum {
  ERROR = "error", // once reported
  REVIEW_ERROR = "review-error", // once EM review it
  WORKING_ON_ERROR = "working-on-error", // once ErrorWO created
  ERROR_REJECTED = "error-rejected", // once reported user reject it
  ERROR_RESOLVED = "error-resolved", // once reported user mark it as resolved.
  ERROR_CLOSED = "error-closed", // once admin mark it as closed.
}

export enum EWayBillPrintType {
  DETAILED = "DETAILED",
  BASIC = "BASIC"
}

export enum CancelReasonEnum {
  DUPLICATE = "DUPLICATE",
  DATA_ENTRY_MISTAKE = "DATA_ENTRY_MISTAKE",
  ORDER_CANCELLED = "ORDER_CANCELLED",
  OTHERS = "OTHERS"
}


export const cancelReasonOptionsForDropDown = [
  { label: "Duplicate", value: 1 },
  { label: "Data entry mistake", value: 2 },
  { label: "Order Cancelled", value: 3 },
  { label: "Others", value: 4 }
];
export const cancelReasonOptions = [
  { label: "Duplicate", value: CancelReasonEnum.DUPLICATE },
  { label: "Data entry mistake", value: CancelReasonEnum.DATA_ENTRY_MISTAKE },
  { label: "Order Cancelled", value: CancelReasonEnum.ORDER_CANCELLED },
  { label: "Others", value: CancelReasonEnum.OTHERS }
];

export const irnStatusOptions = [
  { label: "Generated", value: "GENERATED" },
  { label: "Not Generated", value: "NOT_GENERATED" },
  { label: "Generation Failed", value: "GENERATION_FAILED" },
  { label: "Cancelled", value: "CANCELLED" }
];

export const cdnStatusOptions = [
  { label: "Generated", value: "GENERATED" },
  { label: "Retry", value: "RETRY" },
  // { label: "Not Generated", value: "NOT_GENERATED" },
  // { label: "Generation Failed", value: "GENERATION_FAILED" },
  // { label: "Cancelled", value: "CANCELLED" }
];

export const ewbStatusOptions = [
  { label: "Generated", value: "GENERATED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Expired", value: "EXPIRED" }
];

export const contactTypeOptions = [
  { label: "Driver", value: "driver" },
  { label: "Office Person", value: "officePerson" }
];


export enum InvoiceSendEventEnumEntity {
  START = "start",
  PROGRESS = "progress",
  ERROR = "error",
  COMPLETED = "completed"
}
export enum AddressesProviderAutoCompleteTypeEnumEntity {
  ADDRESS_COMPANY = 'ADDRESS_COMPANY',
  PINCODE = 'PINCODE',
  CITY = 'CITY'
}

export enum AddressesProviderEnum {
  GOOGLE = 'google',
  MAPBOX = 'mapbox'
}

export enum AddressesProviderSearchFieldEnum {
  COMPANY_NAME = "company_name",
  ADDRESS_LINE_1 = "address_line_1",
  CITY = "city",
  PIN_CODE = "pin_code",
}

export const moduleLabelMap: Record<string, string> = {
  social_leads: "Social Leads",
  office: "Office",
  vendors: "Architect",
  ledgerDetails: "Ledger",
  orders: "Order",
  contact: "Contact"
};

export const moduleOptions = Object.entries(moduleLabelMap).map(
  ([value, label]) => ({
    label,
    value
  })
);


export const JbEmporiumIndiaPvtLtdId = '66b1fc30378bd14ec17d288a';

export enum DeliveryAdviceStatusEnumEntity {
  CANCELLED = "cancelled"
}

export enum OfficeMarkerAddressTypeEnumEntity {
  BILLING_ADDRESS = 'BILLING ADDRESS',
  SHOWROOM_ADDRESS = 'SHOWROOM ADDRESS',
}

export enum GoogleMapPlaceTypeEnumEntity {
  CITY = "LOCALITY",
  DIVISION = "ADMINISTRATIVE_AREA_LEVEL_2",
  STATE = "ADMINISTRATIVE_AREA_LEVEL_1",
  COUNTRY = "COUNTRY",
}

export enum UserRoleCategoryEntity {
  SALES_HEAD = "sales head",
  TECHNICIAN = "technician",
  SITE_MANAGER = "site-manager",
}

// export enum EmailForAnalyticsEnumEntity {
//   JARVIS_TEAM = "jb.internal@yopmail.com",
// }

export enum SocialStatusEnumEntity {
  META_FORM = "Meta Form",
  MANUAL = "Manual",
}

export enum DispatchFromEnum {
  SITE = "site",
  FACTORY = "factory",
  VENDOR = "vendor",
}

export enum ModeOfTransportEnum {
  COURIER = "courier",
  TRANSPORT = "transport",
  HAND_CARRY = "handCarry",
}

export enum TBSTypeEnumEntity {
  SKIN = "skin",
  HARDWARE = "hardware",
}

export enum TBSSelectSizeEnumEntity {
  EXACT = "Exact",
  APPROX = "Approx"
}

export enum TBSStatusEnumEntity {
  DRAFT = 'draft',
  IN_TRANSIT = 'in-transit',
  RECEIVED = 'received',
  SEMI_ISSUED = 'semi-issued',
  ISSUED = 'issued',
  CONSUMED = 'consumed',
  RETURNED = 'returned'
}

export enum ProductionDepartmentEnumEntity {
  WHAT_TO_SUPPLY = "what_to_supply",
  WHY_TO_SUPPLY = "why_to_supply",
  ACTION_REQUIRED = "action_required",
  MASTER_ITEM = "master_item"
}


export enum SolutionWorkflowStepStatusEnum {
  PENDING = "pending",
  ACTIVE = "active",
  COMPLETE = "complete",
  HOLD = "hold",
}

export enum ModuleTabNameEnumEntity {
  SALES = "Sales",
  FACTORY = "Factory"
}
/** paint job lifecycle as the backend stores it */
export enum PaintJobStatusEnumEntity {
  PENDING = "pending",
  IN_PROGRESS = "in-progress",
  APPROVAL_PENDING = "approval-pending",
  COMPLETED = "completed",
  HOLD = "hold",
}

/** who created a BOM line item: the add / copy forms, or the sync from the model's CS master mappings */
export enum BOMLineItemSourceEnum {
  MANUAL = "MANUAL",
  MODEL_MAPPING = "MODEL_MAPPING"
}
